var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#145DFD",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3696 11.9565V16.5217M23.3696 16.5217L25.3261 14.5652M23.3696 16.5217L21.4131 14.5652M9.67392 25V24.3478C9.67392 22.9641 10.2236 21.637 11.2021 20.6586C12.1805 19.6801 13.5076 19.1304 14.8913 19.1304H16.1957C17.5794 19.1304 18.9065 19.6801 19.8849 20.6586C20.8634 21.637 21.4131 22.9641 21.4131 24.3478V25M18.8044 13.2609C18.8044 14.1257 18.4608 14.9551 17.8493 15.5667C17.2377 16.1782 16.4083 16.5217 15.5435 16.5217C14.6786 16.5217 13.8492 16.1782 13.2377 15.5667C12.6262 14.9551 12.2826 14.1257 12.2826 13.2609C12.2826 12.396 12.6262 11.5666 13.2377 10.9551C13.8492 10.3436 14.6786 10 15.5435 10C16.4083 10 17.2377 10.3436 17.8493 10.9551C18.4608 11.5666 18.8044 12.396 18.8044 13.2609Z",
    stroke: "#145DFD",
    strokeWidth: 1.28,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveRequestIcon);
export default __webpack_public_path__ + "static/media/LeaveRequestIcon.bf82d3470d874e74f2578e4b701494a6.svg";
export { ForwardRef as ReactComponent };